  import { defineComponent, type PropType } from "vue";
  import EtablissementSelect from '@/extend/controls/etablissement/EtablissementSelect';
  import ManualBillingDocumentAmountHt from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountHt';
  import ManualBillingDocumentAmountTtc from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountTtc';
  import ManualBillingDocumentAmountTva from '@/extend/controls/manualBillingDocument/ManualBillingDocumentAmountTva';
  import ManualBillingDocumentDocumentReference from '@/extend/controls/manualBillingDocument/ManualBillingDocumentDocumentReference';
  import ManualBillingDocumentEffectiveAt from '@/extend/controls/manualBillingDocument/ManualBillingDocumentEffectiveAt';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import ManualBillingDocumentInCart from '@/extend/controls/manualBillingDocument/ManualBillingDocumentInCart';
  import ManualBillingDocumentKind from '@/extend/controls/manualBillingDocument/ManualBillingDocumentKind';
  import ManualBillingDocumentLabel from '@/extend/controls/manualBillingDocument/ManualBillingDocumentLabel';
  import ManualBillingDocumentLedgerCode from '@/extend/controls/manualBillingDocument/ManualBillingDocumentLedgerCode';
  import ManualBillingDocumentPaymentMethod from '@/extend/controls/manualBillingDocument/ManualBillingDocumentPaymentMethod';
  import ManualBillingDocumentReference from '@/extend/controls/manualBillingDocument/ManualBillingDocumentReference';
  import ManualBillingDocumentVatRate from '@/extend/controls/manualBillingDocument/ManualBillingDocumentVatRate';
  import ManualBillingDocument from '@/extend/classes/ManualBillingDocument';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeManualBillingDocument } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      EtablissementSelect,
      ManualBillingDocumentAmountHt,
      ManualBillingDocumentAmountTtc,
      ManualBillingDocumentAmountTva,
      ManualBillingDocumentDocumentReference,
      ManualBillingDocumentEffectiveAt,
      ManualBillingDocumentInCart,
      ManualBillingDocumentKind,
      ManualBillingDocumentLabel,
      ManualBillingDocumentLedgerCode,
      ManualBillingDocumentPaymentMethod,
      ManualBillingDocumentReference,
      ManualBillingDocumentVatRate,
    },

    props: {
      manualBillingDocument: {
        type: Object as PropType<ManualBillingDocument>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetEtablissementSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
    toggleEtablissementId: false,
        etablissementIdStatus: new FieldStatus(false, false, 0),
        strEtablissementId: '',
        amountHtStatus: new FieldStatus(false, false, 0),
        strAmountHt: '',
        amountTtcStatus: new FieldStatus(false, false, 0),
        strAmountTtc: '',
        amountTvaStatus: new FieldStatus(false, false, 0),
        strAmountTva: '',
        documentReferenceStatus: new FieldStatus(false, false, 0),
        strDocumentReference: '',
        effectiveAtStatus: new FieldStatus(false, false, 0),
        strEffectiveAt: '',
        inCartStatus: new FieldStatus(false, false, 0),
        strInCart: '',
        kindStatus: new FieldStatus(false, false, 0),
        strKind: '',
        labelStatus: new FieldStatus(false, false, 0),
        strLabel: '',
        ledgerCodeStatus: new FieldStatus(false, false, 0),
        strLedgerCode: '',
        paymentMethodStatus: new FieldStatus(false, false, 0),
        strPaymentMethod: '',
        referenceStatus: new FieldStatus(false, false, 0),
        strReference: '',
        vatRateStatus: new FieldStatus(false, false, 0),
        strVatRate: '',
        refManualBillingDocument: new ManualBillingDocument,
        cloneManualBillingDocument: new ManualBillingDocument,
      manualBillingDocumentSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.MANUAL_BILLING_DOCUMENT,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editManualBillingDocument.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editManualBillingDocument: {
        get(): ManualBillingDocument {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.manualBillingDocument != undefined) {
              if (this.manualBillingDocument.id == 0) {
                Alerts.debug('CrudManualBillingDocument : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneManualBillingDocument.id != this.manualBillingDocument.id && !this.saving) {
                this.handleManualBillingDocumentChange();
              }
            }
          }
          return this.refManualBillingDocument;
        },
        set(value: ManualBillingDocument) {
          this.refManualBillingDocument = value;
        }
      },

      canCreate (): boolean {
        return this.refManualBillingDocument.id > 0;
      },

      canDelete (): boolean {
        return this.refManualBillingDocument.canDelete && this.refManualBillingDocument.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },

    resetEtablissementId (): boolean {
      return this.toggleEtablissementId
    },

      etablissementId: {
        get(): number {
          return this.editManualBillingDocument.etablissementId;
        },
        set(value: number) {
          this.editManualBillingDocument.etablissementId = value;
          this.fieldUpdated('ETABLISSEMENT_ID', value);
        }
      },


      amountHt: {
        get(): string {
          return this.strAmountHt;
        },
        set(value: string) {
          const amountHt = parseFloat(value);
          if (amountHt.toString() == value) {
            this.editManualBillingDocument.amountHt = amountHt;
            this.fieldUpdated('AMOUNT_HT', value);
          }
          this.strAmountHt = value;
        }
      },


      amountTtc: {
        get(): string {
          return this.strAmountTtc;
        },
        set(value: string) {
          const amountTtc = parseFloat(value);
          if (amountTtc.toString() == value) {
            this.editManualBillingDocument.amountTtc = amountTtc;
            this.fieldUpdated('AMOUNT_TTC', value);
          }
          this.strAmountTtc = value;
        }
      },


      amountTva: {
        get(): string {
          return this.strAmountTva;
        },
        set(value: string) {
          const amountTva = parseFloat(value);
          if (amountTva.toString() == value) {
            this.editManualBillingDocument.amountTva = amountTva;
            this.fieldUpdated('AMOUNT_TVA', value);
          }
          this.strAmountTva = value;
        }
      },


      documentReference: {
        get(): string {
          return this.editManualBillingDocument.documentReference;
        },
        set(value: string) {
          this.editManualBillingDocument.documentReference = value;
          this.fieldUpdated('DOCUMENT_REFERENCE', value);
        }
      },


      effectiveAt: {
        get(): Date {
          return this.editManualBillingDocument.effectiveAt;
        },
        set(value: Date) {
          this.editManualBillingDocument.effectiveAt = value;
          this.fieldUpdated('EFFECTIVE_AT', value);
        }
      },

      periodEffectiveAt() : Period[] {
        return []
      },

      inCart: {
        get(): boolean | null {
          return this.editManualBillingDocument.inCart;
        },
        set(value: boolean | null) {
          this.editManualBillingDocument.inCart = value;
          this.fieldUpdated('IN_CART', value);
        }
      },


      kind: {
        get(): number {
          return this.editManualBillingDocument.kind;
        },
        set(value: number) {
          this.editManualBillingDocument.kind = value;
          this.fieldUpdated('KIND', value);
        }
      },


      label: {
        get(): string {
          return this.editManualBillingDocument.label;
        },
        set(value: string) {
          this.editManualBillingDocument.label = value;
          this.fieldUpdated('LABEL', value);
        }
      },


      ledgerCode: {
        get(): number {
          return this.editManualBillingDocument.ledgerCode;
        },
        set(value: number) {
          this.editManualBillingDocument.ledgerCode = value;
          this.fieldUpdated('LEDGER_CODE', value);
        }
      },


      paymentMethod: {
        get(): string {
          return this.editManualBillingDocument.paymentMethod;
        },
        set(value: string) {
          this.editManualBillingDocument.paymentMethod = value;
          this.fieldUpdated('PAYMENT_METHOD', value);
        }
      },


      reference: {
        get(): string {
          return this.editManualBillingDocument.reference;
        },
        set(value: string) {
          this.editManualBillingDocument.reference = value;
          this.fieldUpdated('REFERENCE', value);
        }
      },


      vatRate: {
        get(): string {
          return this.strVatRate;
        },
        set(value: string) {
          const vatRate = parseFloat(value);
          if (vatRate.toString() == value) {
            this.editManualBillingDocument.vatRate = vatRate;
            this.fieldUpdated('VAT_RATE', value);
          }
          this.strVatRate = value;
        }
      },


      allReadOnly (): boolean {
        const res = this.manualBillingDocument.canUpdate && (
        (this.isDisplayed('ETABLISSEMENT_ID') && !this.readOnly('ETABLISSEMENT_ID')) ||
        (this.isDisplayed('AMOUNT_HT') && !this.readOnly('AMOUNT_HT')) ||
        (this.isDisplayed('AMOUNT_TTC') && !this.readOnly('AMOUNT_TTC')) ||
        (this.isDisplayed('AMOUNT_TVA') && !this.readOnly('AMOUNT_TVA')) ||
        (this.isDisplayed('DOCUMENT_REFERENCE') && !this.readOnly('DOCUMENT_REFERENCE')) ||
        (this.isDisplayed('EFFECTIVE_AT') && !this.readOnly('EFFECTIVE_AT')) ||
        (this.isDisplayed('IN_CART') && !this.readOnly('IN_CART')) ||
        (this.isDisplayed('KIND') && !this.readOnly('KIND')) ||
        (this.isDisplayed('LABEL') && !this.readOnly('LABEL')) ||
        (this.isDisplayed('LEDGER_CODE') && !this.readOnly('LEDGER_CODE')) ||
        (this.isDisplayed('PAYMENT_METHOD') && !this.readOnly('PAYMENT_METHOD')) ||
        (this.isDisplayed('REFERENCE') && !this.readOnly('REFERENCE')) ||
        (this.isDisplayed('VAT_RATE') && !this.readOnly('VAT_RATE')));
        return !res;
      },

      fields (): string[] {
        return ['ETABLISSEMENT_ID', 'AMOUNT_HT', 'AMOUNT_TTC', 'AMOUNT_TVA', 'DOCUMENT_REFERENCE', 'EFFECTIVE_AT', 'IN_CART', 'KIND', 'LABEL', 'LEDGER_CODE', 'PAYMENT_METHOD', 'REFERENCE', 'VAT_RATE'];
      },
    },

    methods: {
      handleManualBillingDocumentChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.manualBillingDocument);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.manualBillingDocument);
          }
        } else if (!this.inDialog) {
          if (this.cloneManualBillingDocument.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.manualBillingDocument);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.etablissementIdStatus != undefined && this.etablissementIdStatus.updated) ||
          (this.amountHtStatus != undefined && this.amountHtStatus.updated) ||
          (this.amountTtcStatus != undefined && this.amountTtcStatus.updated) ||
          (this.amountTvaStatus != undefined && this.amountTvaStatus.updated) ||
          (this.documentReferenceStatus != undefined && this.documentReferenceStatus.updated) ||
          (this.effectiveAtStatus != undefined && this.effectiveAtStatus.updated) ||
          (this.inCartStatus != undefined && this.inCartStatus.updated) ||
          (this.kindStatus != undefined && this.kindStatus.updated) ||
          (this.labelStatus != undefined && this.labelStatus.updated) ||
          (this.ledgerCodeStatus != undefined && this.ledgerCodeStatus.updated) ||
          (this.paymentMethodStatus != undefined && this.paymentMethodStatus.updated) ||
          (this.referenceStatus != undefined && this.referenceStatus.updated) ||
          (this.vatRateStatus != undefined && this.vatRateStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.manualBillingDocument);
        }
      },

      setError (): void {
        const error = this.etablissementIdStatus.error ||
        this.amountHtStatus.error ||
        this.amountTtcStatus.error ||
        this.amountTvaStatus.error ||
        this.documentReferenceStatus.error ||
        this.effectiveAtStatus.error ||
        this.inCartStatus.error ||
        this.kindStatus.error ||
        this.labelStatus.error ||
        this.ledgerCodeStatus.error ||
        this.paymentMethodStatus.error ||
        this.referenceStatus.error ||
        this.vatRateStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.manualBillingDocument);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refManualBillingDocument.id < 0) {
          storeManualBillingDocument.mManualBillingDocumentDeleted(this.refManualBillingDocument.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refManualBillingDocument.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveManualBillingDocument()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.manualBillingDocumentSaving = false;
          this.createRef(this.refManualBillingDocument);
          this.$emit('updated', this.refManualBillingDocument);
          if (this.manualBillingDocument.id > 0) {
            this.$emit('saved', this.refManualBillingDocument);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refManualBillingDocument.failed) {
          this.saveLoading = false;
            this.manualBillingDocumentSaving = false;
            this.refManualBillingDocument.failed = false;
          }
        }
      },

      saveManualBillingDocument (): boolean {
        if (!this.refManualBillingDocument.compareManualBillingDocument(this.cloneManualBillingDocument)) {
          if (!this.manualBillingDocumentSaving) {
            this.manualBillingDocumentSaving = true;
          if (this.refManualBillingDocument.id > 0) {
            storeManualBillingDocument.updateManualBillingDocument(this.refManualBillingDocument)
              .then((data: ManualBillingDocument) => {
                if (!data.failed) {
                  this.refManualBillingDocument = storeManualBillingDocument.getManualBillingDocument(data.id);
                  this.cloneManualBillingDocument = data.cloneManualBillingDocument();
                } else {
                  this.refManualBillingDocument.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.manualBillingDocumentSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refManualBillingDocument.id <= 0) {
              storeManualBillingDocument.createManualBillingDocument(this.refManualBillingDocument)
                .then((data: ManualBillingDocument) => {
                  if (!data.failed) {
                    this.refManualBillingDocument = storeManualBillingDocument.getManualBillingDocument(data.id);
                    this.cloneManualBillingDocument = data.cloneManualBillingDocument();
                  } else {
                this.refManualBillingDocument.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.manualBillingDocumentSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refManualBillingDocument.id <= 0) {
          storeManualBillingDocument.mManualBillingDocumentDeleted(this.refManualBillingDocument.id);
        }
      },

      statusEtablissementId (value: FieldStatus): void {
        this.etablissementIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAmountHt (value: FieldStatus): void {
        this.amountHtStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAmountTtc (value: FieldStatus): void {
        this.amountTtcStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAmountTva (value: FieldStatus): void {
        this.amountTvaStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDocumentReference (value: FieldStatus): void {
        this.documentReferenceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusEffectiveAt (value: FieldStatus): void {
        this.effectiveAtStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusInCart (value: FieldStatus): void {
        this.inCartStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusKind (value: FieldStatus): void {
        this.kindStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLabel (value: FieldStatus): void {
        this.labelStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLedgerCode (value: FieldStatus): void {
        this.ledgerCodeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPaymentMethod (value: FieldStatus): void {
        this.paymentMethodStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusReference (value: FieldStatus): void {
        this.referenceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusVatRate (value: FieldStatus): void {
        this.vatRateStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteManualBillingDocument(): void {
        this.$emit('deleteManualBillingDocument',  this.manualBillingDocument);
      },

    addManualBillingDocument(): void {
      this.$emit('addManualBillingDocument',  this.manualBillingDocument);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneManualBillingDocument != undefined) {
          this.restoring = true;
          this.refManualBillingDocument.etablissementId = this.cloneManualBillingDocument.etablissementId;
          this.refManualBillingDocument.amountHt = this.cloneManualBillingDocument.amountHt;
          this.refManualBillingDocument.amountTtc = this.cloneManualBillingDocument.amountTtc;
          this.refManualBillingDocument.amountTva = this.cloneManualBillingDocument.amountTva;
          this.refManualBillingDocument.documentReference = this.cloneManualBillingDocument.documentReference;
          this.refManualBillingDocument.effectiveAt = this.cloneManualBillingDocument.effectiveAt;
          this.refManualBillingDocument.inCart = this.cloneManualBillingDocument.inCart;
          this.refManualBillingDocument.kind = this.cloneManualBillingDocument.kind;
          this.refManualBillingDocument.label = this.cloneManualBillingDocument.label;
          this.refManualBillingDocument.ledgerCode = this.cloneManualBillingDocument.ledgerCode;
          this.refManualBillingDocument.paymentMethod = this.cloneManualBillingDocument.paymentMethod;
          this.refManualBillingDocument.reference = this.cloneManualBillingDocument.reference;
          this.refManualBillingDocument.vatRate = this.cloneManualBillingDocument.vatRate;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: ManualBillingDocument): void {
        this.clearRef();
        this.editManualBillingDocument = value;
        this.cloneManualBillingDocument = value.cloneManualBillingDocument();
        this.etablissementIdStatus.clear(value.id);
        this.amountHtStatus.clear(value.id);
        this.amountTtcStatus.clear(value.id);
        this.amountTvaStatus.clear(value.id);
        this.documentReferenceStatus.clear(value.id);
        this.effectiveAtStatus.clear(value.id);
        this.inCartStatus.clear(value.id);
        this.kindStatus.clear(value.id);
        this.labelStatus.clear(value.id);
        this.ledgerCodeStatus.clear(value.id);
        this.paymentMethodStatus.clear(value.id);
        this.referenceStatus.clear(value.id);
        this.vatRateStatus.clear(value.id);
        this.status.clear();
        this.strAmountHt = this.editManualBillingDocument.amountHt.toString();
        this.strAmountTtc = this.editManualBillingDocument.amountTtc.toString();
        this.strAmountTva = this.editManualBillingDocument.amountTva.toString();
        this.strVatRate = this.editManualBillingDocument.vatRate.toString();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_HT') && this.$refs.AMOUNT_HT) this.$refs.AMOUNT_HT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_TTC') && this.$refs.AMOUNT_TTC) this.$refs.AMOUNT_TTC.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_TVA') && this.$refs.AMOUNT_TVA) this.$refs.AMOUNT_TVA.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DOCUMENT_REFERENCE') && this.$refs.DOCUMENT_REFERENCE) this.$refs.DOCUMENT_REFERENCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EFFECTIVE_AT') && this.$refs.EFFECTIVE_AT) this.$refs.EFFECTIVE_AT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IN_CART') && this.$refs.IN_CART) this.$refs.IN_CART.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('KIND') && this.$refs.KIND) this.$refs.KIND.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LEDGER_CODE') && this.$refs.LEDGER_CODE) this.$refs.LEDGER_CODE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYMENT_METHOD') && this.$refs.PAYMENT_METHOD) this.$refs.PAYMENT_METHOD.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('REFERENCE') && this.$refs.REFERENCE) this.$refs.REFERENCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VAT_RATE') && this.$refs.VAT_RATE) this.$refs.VAT_RATE.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ETABLISSEMENT_ID') && this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID && this.$refs.ETABLISSEMENT_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'AMOUNT_HT') && this.isDisplayed('AMOUNT_HT') && this.$refs.AMOUNT_HT && this.$refs.AMOUNT_HT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'AMOUNT_TTC') && this.isDisplayed('AMOUNT_TTC') && this.$refs.AMOUNT_TTC && this.$refs.AMOUNT_TTC.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'AMOUNT_TVA') && this.isDisplayed('AMOUNT_TVA') && this.$refs.AMOUNT_TVA && this.$refs.AMOUNT_TVA.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DOCUMENT_REFERENCE') && this.isDisplayed('DOCUMENT_REFERENCE') && this.$refs.DOCUMENT_REFERENCE && this.$refs.DOCUMENT_REFERENCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'EFFECTIVE_AT') && this.isDisplayed('EFFECTIVE_AT') && this.$refs.EFFECTIVE_AT && this.$refs.EFFECTIVE_AT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'IN_CART') && this.isDisplayed('IN_CART') && this.$refs.IN_CART && this.$refs.IN_CART.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'KIND') && this.isDisplayed('KIND') && this.$refs.KIND && this.$refs.KIND.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LABEL') && this.isDisplayed('LABEL') && this.$refs.LABEL && this.$refs.LABEL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LEDGER_CODE') && this.isDisplayed('LEDGER_CODE') && this.$refs.LEDGER_CODE && this.$refs.LEDGER_CODE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PAYMENT_METHOD') && this.isDisplayed('PAYMENT_METHOD') && this.$refs.PAYMENT_METHOD && this.$refs.PAYMENT_METHOD.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'REFERENCE') && this.isDisplayed('REFERENCE') && this.$refs.REFERENCE && this.$refs.REFERENCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'VAT_RATE') && this.isDisplayed('VAT_RATE') && this.$refs.VAT_RATE && this.$refs.VAT_RATE.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_HT') && this.$refs.AMOUNT_HT) this.$refs.AMOUNT_HT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_TTC') && this.$refs.AMOUNT_TTC) this.$refs.AMOUNT_TTC.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AMOUNT_TVA') && this.$refs.AMOUNT_TVA) this.$refs.AMOUNT_TVA.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DOCUMENT_REFERENCE') && this.$refs.DOCUMENT_REFERENCE) this.$refs.DOCUMENT_REFERENCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EFFECTIVE_AT') && this.$refs.EFFECTIVE_AT) this.$refs.EFFECTIVE_AT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IN_CART') && this.$refs.IN_CART) this.$refs.IN_CART.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('KIND') && this.$refs.KIND) this.$refs.KIND.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LEDGER_CODE') && this.$refs.LEDGER_CODE) this.$refs.LEDGER_CODE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYMENT_METHOD') && this.$refs.PAYMENT_METHOD) this.$refs.PAYMENT_METHOD.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('REFERENCE') && this.$refs.REFERENCE) this.$refs.REFERENCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VAT_RATE') && this.$refs.VAT_RATE) this.$refs.VAT_RATE.save();
      },

      getValue (field: string): string {
         if (field == 'ETABLISSEMENT_ID') return this.etablissementId.toString();
        else  if (field == 'AMOUNT_HT') return this.amountHt.toString();
        else  if (field == 'AMOUNT_TTC') return this.amountTtc.toString();
        else  if (field == 'AMOUNT_TVA') return this.amountTva.toString();
        else  if (field == 'DOCUMENT_REFERENCE') return this.documentReference.toString();
        else  if (field == 'EFFECTIVE_AT') return this.effectiveAt.toString();
        else  if (field == 'IN_CART') return this.inCart == null ? '' : this.inCart.toString();
        else  if (field == 'KIND') return this.kind.toString();
        else  if (field == 'LABEL') return this.label.toString();
        else  if (field == 'LEDGER_CODE') return this.ledgerCode.toString();
        else  if (field == 'PAYMENT_METHOD') return this.paymentMethod.toString();
        else  if (field == 'REFERENCE') return this.reference.toString();
        else  if (field == 'VAT_RATE') return this.vatRate.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
